import React, { useState, useEffect } from 'react';
import categoriasJson from './worksJson.js';
import './works.css'; 
import bgworks from '../images/bgworks.webp';
import bgworkspath from '../images/bgworkspath.webp';
import ArrowRight from './ArrowRights.js';


function Works() {
  const [visibleItems, setVisibleItems] = useState([]);
  const [itemsToShow, setItemsToShow] = useState(10);

  useEffect(() => {
    setVisibleItems(categoriasJson.slice(0, itemsToShow));
  }, [itemsToShow]);

  const handleLoadMore = () => {
    setItemsToShow(prevCount => prevCount + 10);
  };

  return (   
    <section className='works' style={{ backgroundImage: `url(${bgworks}),url(${bgworkspath})` }}>
      <div className='content'>
        <div className='titles'>
          <h2>Works <sub>-</sub></h2>
          <ArrowRight className="custom-arrow" />
          <a href='/works' className='buttonIndexBlack'>more about works</a>
        </div>
        <ol className='worksOl'>
          {visibleItems.map((cats) => {
            let img = `${process.env.PUBLIC_URL}/images/works/${cats.alt}.webp`;
            const text = cats.texto;
            const titulo = cats.titulo;
            const tags = cats.tags;

            const tagElements = tags && tags.trim() !== ""
                ? tags.split("-").map((tag, index) => <span key={index}>{tag.trim()}</span>)
                : null;

            return (
              <li key={cats.titulo}>
                <figure style={{ backgroundImage: `url(${img})` }}>
                  <div className='text'>
                    <h4>{cats.titulo}</h4>
                  <p>{text}</p>
                  {tagElements && (
                      <div className='tags'>
                          {tagElements}
                      </div>
                  )}
                </div>
                  <img width="100%" src={img} alt={titulo}></img>
                </figure>
              </li>
            );
          })}
        </ol>
        {itemsToShow < categoriasJson.length && (
            <button onClick={handleLoadMore} className='buttonIndexBlack toggle-button'>more works +</button>
        )}
      </div>
    </section>
  );
}

export default Works;